/**
 * @generated SignedSource<<15fa2bfcbd83c9457cef40770bb3ef79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionColumn_TreeStateFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "ActionColumn_TreeStateFragment";
};
export type ActionColumn_TreeStateFragment$key = {
  readonly " $data"?: ActionColumn_TreeStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionColumn_TreeStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionColumn_TreeStateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TreeState",
  "abstractKey": null
};

(node as any).hash = "064ba5d2b5f6907ab6b9d436ca519c00";

export default node;
